export const RootPath = '/'
export const LoginPath = '/login'
export const ProfilePath = '/profile'
export const InternalPath = '/internal'
export const PoolsPath = '/pools'
export const ScreenersPath = (poolId: number): string => { return `/pools/${poolId}/screeners` }
export const ParticipantsPath = (poolId: number): string => { return `/pools/${poolId}/participants` }
export const PublicScreenerPath = (key: string): string => { return `/screeners/${key}` }
